<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div :class="banner.class">
          <div class="banner-content">
            <ion-icon mode="ios" name="checkmark-circle" size="large" color="primary"></ion-icon>
            <p class="mt-2 mb-1 text-xxl bold green">Parabéns!</p>
            <p class="mt-0 mb-0 text-md thin green">Sua assinatura Updiet foi ativada</p>
            <ion-spinner name="crescent" class="mt-3" color="primary"></ion-spinner>
          </div>
        </div>
        <div class="logo mb-4">
          <ion-img
            src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/new-assets%2Fbrand%2FUpdiet_NewIcon.png?alt=media&token=834dbefe-8bfd-4cc4-b8fa-ef6b035414f5"
          ></ion-img>
        </div>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <div class="popup-subscribe">
          <p
            v-if="firstName"
            class="subscribe-header mt-2 mb-2 text-xxl bold white ion-text-center"
          >Prontinho, {{ firstName }}!</p>
          <p
            v-else
            class="subscribe-header mt-2 mb-2 text-xxl bold white ion-text-center"
          >Prontinho!</p>
          <p class="subscribe-header ion-text-center mb-0 mt-0 text-lg white">
            Montamos uma dieta
            <br />personalizada pra você &#128522;
          </p>
          <ul class="mt-4 white pt-2 pb-2 pl-3 pr-3 border-50">
            <li class="mt-3 mb-3 d-flex-align-center">
              <ion-icon name="list-box" mode="ios"></ion-icon>
              <span>Menu semanal com lista de compras</span>
            </li>
            <li class="mt-3 mb-3 d-flex-align-center">
              <ion-icon name="albums" mode="ios"></ion-icon>
              <span>+ 1.500 receitas fáceis, saudáveis e deliciosas</span>
            </li>
            <li class="mt-3 mb-3 d-flex-align-center">
              <ion-icon name="disc" mode="ios"></ion-icon>
              <span>Plano desenvolvido para resultados rápidos</span>
            </li>
            <div class="pt-2 mb-2">
              <div class="pseudo-button pt-3 pb-3 pl-4" @click="subscribeMonthly">
                <p class="mt-0 pseudo-button-p-margin-bottom text-left text-lg bold green">1 Mês</p>
                <p class="mt-0 mb-0 text-left text-md green">por apenas R$ 14,90</p>
                <div class="selected-icon">
                  <ion-icon mode="ios" name="arrow-round-forward" class="green"></ion-icon>
                </div>
              </div>
            </div>
            <div class="pt-2 mb-1">
              <div class="pseudo-button-green pt-3 pb-3 pl-4" @click="subscribeYearly">
                <p class="mt-0 pseudo-button-p-margin-bottom text-left text-lg bold">1 Ano</p>
                <p class="mt-0 mb-0 text-left text-md">por apenas R$ 99,90</p>
                <p class="mt-2 mb-0 text-left text-md bold">(45% mais barato)</p>
                <div class="selected-icon">
                  <ion-icon mode="ios" name="arrow-round-forward" class="white"></ion-icon>
                </div>
              </div>
            </div>
          </ul>
          <div class="subscribe-bottom mt-4 mb-3">
            <p
              class="mt-5 mb-3 thin text-sm white ion-text-center cursor-pointer"
              @click="restoreSubscription"
            >Restaurar assinatura</p>
            <p class="legal-text mt-3 mb-0 thin white text-xs" align="justify">
              Essa assinatura é renovada automaticamente pelo preço contratado a cada
              novo ciclo de cobrança e pode ser cancelada a qualquer momento. Ao
              assinar, você está concordando com nossos
              <span
                @click="gotoLegal"
                class="green cursor-pointer"
              >Termos</span> e
              <span @click="gotoLegal" class="green cursor-pointer">Privacidade</span>.
            </p>
          </div>
        </div>
      </ion-grid>
    </ion-content>
  </ion-app>
</template>

<script>
// in-app-purchase
// import inAppPurchase from "cordova-plugin-inapppurchase";
import { InAppPurchase } from "@ionic-native/in-app-purchase";
// capacitor
import { Plugins } from "@capacitor/core";
const { Device } = Plugins;
// firebase
import db from "@/firebase/init";
import firebase from "firebase";
import functions from "firebase/functions";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// store
import store from "../../utils/store.js";
// component
export default {
  name: "SubscribePage",
  components: {
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      banner: {
        class: "banner-message p-3 d-none"
      },
      isLoading: false,
      fullPage: true,
      user: store.state.user,
      profile: store.state.profile,
      firstName: null
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    clearBanner() {
      this.notification = {
        class: "banner-message p-3 d-none"
      };
    },
    gotoBack() {
      this.$router.go(-1);
    },
    gotoLegal() {
      this.$router.push({
        name: "Legal"
      });
    },
    async subscribeMonthly() {
      const instance = this;
      if (instance.profile.data.subscriptionStatus) {
        instance.notification = {
          class: "error-message p-3",
          message: "Você já é assinante do Updiet."
        };
        setTimeout(() => {
          instance.clearNotification();
        }, 3000);
        this.$router.push({
          name: "Meal Plan"
        });
      } else {
        instance.startLoading();
        const userRef = db.collection("users").doc(instance.profile.id);
        const info = await Device.getInfo();
        const platform = info.platform;
        let products;
        try {
          if (platform === "android") {
            products = await InAppPurchase.getProducts(["updietmensal2020"]);
          } else if (platform === "ios") {
            products = await InAppPurchase.getProducts(["updietMensal2020"]);
          }
          if (products) {
            const result = await InAppPurchase.subscribe(products[0].productId);
            if (result) {
              instance.isLoading = true;
              const validateReceipt = await firebase
                .functions()
                .httpsCallable("validateReceipt");
              validateReceipt({
                result: result,
                platform: platform,
                userId: instance.profile.id
              });
              instance.profile.data.subscriptionStatus = true;
              instance.profile.data.subscriptionPlan = "monthly";
              instance.profile.data.subscriptionDate = new Date();
              store.state.profile = instance.profile;
              await userRef.update({
                subscriptionStatus: true,
                subscriptionPlan: "monthly",
                subscriptionDate: new Date(),
                subscriptionReceipt: result.receipt
              });
              instance.$router.push({
                name: "Meal Plan"
              });
            } else {
              instance.isLoading = false;
              instance.notification = {
                class: "error-message p-3",
                message:
                  "Ocorreu um erro ao realizar sua assinatura. Tente novamente."
              };
              setTimeout(() => {
                instance.clearNotification();
              }, 3000);
            }
          } else {
            instance.isLoading = false;
            instance.notification = {
              class: "error-message p-3",
              message:
                "Ocorreu um erro ao conectar com a loja. Tente novamente."
            };
            setTimeout(() => {
              instance.clearNotification();
            }, 3000);
          }
        } catch (e) {
          console.log(e);
          instance.isLoading = false;
        }
      }
    },
    async subscribeYearly() {
      const instance = this;
      if (instance.profile.data.subscriptionStatus) {
        instance.notification = {
          class: "error-message p-3",
          message: "Você já é assinante do Updiet."
        };
        setTimeout(() => {
          instance.clearNotification();
        }, 3000);
        this.$router.push({
          name: "Meal Plan"
        });
      } else {
        instance.startLoading();
        const userRef = db.collection("users").doc(instance.profile.id);
        const info = await Device.getInfo();
        const platform = info.platform;
        let products;
        try {
          if (platform === "android") {
            products = await InAppPurchase.getProducts(["updietanual2020"]);
          } else if (platform === "ios") {
            products = await InAppPurchase.getProducts(["updietAnual2020"]);
          }
          if (products) {
            const result = await InAppPurchase.subscribe(products[0].productId);
            if (result) {
              instance.isLoading = true;
              const validateReceipt = await firebase
                .functions()
                .httpsCallable("validateReceipt");
              validateReceipt({
                result: result,
                platform: platform,
                userId: instance.profile.id
              });
              instance.profile.data.subscriptionStatus = true;
              instance.profile.data.subscriptionPlan = "yearly";
              instance.profile.data.subscriptionDate = new Date();
              store.state.profile = instance.profile;
              await userRef.update({
                subscriptionStatus: true,
                subscriptionPlan: "yearly",
                subscriptionDate: new Date(),
                subscriptionReceipt: result.receipt
              });
              instance.$router.push({
                name: "Meal Plan"
              });
            } else {
              instance.isLoading = false;
              instance.notification = {
                class: "error-message p-3",
                message:
                  "Ocorreu um erro ao realizar sua assinatura. Tente novamente."
              };
              setTimeout(() => {
                instance.clearNotification();
              }, 3000);
            }
          } else {
            instance.isLoading = false;
            instance.notification = {
              class: "error-message p-3",
              message:
                "Ocorreu um erro ao conectar com a loja. Tente novamente."
            };
            setTimeout(() => {
              instance.clearNotification();
            }, 3000);
          }
        } catch (e) {
          console.log(e);
          instance.isLoading = false;
        }
      }
    },
    async restoreSubscription() {
      const instance = this;
      if (instance.profile.data.subscriptionStatus) {
        instance.isLoading = true;
        setTimeout(() => {
          instance.isLoading = false;
          this.$router.push({
            name: "Meal Plan"
          });
        }, 3000);
      } else {
        instance.notification = {
          class: "error-message p-3",
          message: "Você não possui uma assinatura ativa para restaurar."
        };
        setTimeout(() => {
          instance.clearNotification();
        }, 3000);
      }
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
    const name = instance.profile.data.name;
    const firstName = name.replace(/ .*/, "");
    instance.firstName = firstName;
    try {
      if (instance.profile.data.subscriptionStatus) {
        /*
        this.$router.push({
          name: "Meal Plan"
        });
        */
      }
    } catch (e) {
      console.log(e);
      instance.isLoading = false;
    }
  }
};
</script>

<style scoped>
ion-content {
  --background: var(--bg-color-blue) !important;
}
ion-item {
  --padding-start: 30px;
  --padding-end: 30px;
}
.logo ion-img {
  height: 10vw;
  width: auto;
}
.popup-subscribe {
  width: 100%;
  max-width: 800px;
}
.subscribe-header {
  padding-left: 5vw;
  padding-right: 5vw;
}
.subscribe-bottom {
  width: 100%;
  max-width: 800px;
  padding-left: 5vw;
  padding-right: 5vw;
}
.legal-text {
  padding-left: 5vw;
  padding-right: 5vw;
}
ul {
  list-style-type: none;
  padding-right: 5vw;
  padding-left: 5vw;
}
ul li {
  font-size: 0.9rem;
}
ul ion-icon {
  font-size: 2rem !important;
  margin-right: 10px;
}
.promo-text {
  display: flex;
  justify-content: center;
  text-align: center !important;
}
.border-50 {
  border-radius: 30px;
  box-shadow: -6px -6px 3px -3px rgba(0, 0, 0, 0.15);
  background: rgb(15, 68, 146);
}
</style>
